import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';

import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import { getProductDetail } from '../../shared/requests/shop/ProductRequests';
import { addProductToCart } from '../../shared/requests/shop/CartRequests';
import { getUserInfo } from '../../shared/requests/UserInfoRequests';
import productPlaceholder from '../../static/img/product_placeholder.jpg';

const styles = theme => ({
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  loadingSpinner: {
    margin: theme.spacing(3),
  },
  paper: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 800,
    padding: theme.spacing(3),
    margin: theme.spacing(3),
  },
  media: {
    width: '100%',
    padding: theme.spacing(2),
  },
  cardActions: {
    margin: theme.spacing(),
    justifyContent: 'center',
  },
  sectionTitle: {
    marginBottom: theme.spacing(3),
  },
  buttonAndPrice: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  price: {
    margin: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(2),
  },
  tooltipWrapper: {
    display: 'inline-flex',
  },
  font: {
    fontFamily: theme.typography.body1.fontFamily,
  },
});

class ProductDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      hasMembership: false,
      category: '',
      loading: true,
      addButtonLoading: false,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      product: null,
    };

    this.handleClose = this.handleClose.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }

  componentDidMount() {
    const { productId } = this.props.match.params;
    const { token, id } = this.props;

    // check if logged in
    if (token) {
      this.setState({
        loggedIn: true,
      });
    }

    let category = '';
    // get products in category
    getProductDetail(productId)
      .then((response) => {
        // console.log(response.data);
        category = response.data.categories[0];
        this.setState({
          category,
          product: response.data,
          loading: false,
        });

        // does user have membership?
        if (token && id) {
          getUserInfo(token, id)
            .then((response) => {
              console.log('got user info');
              this.setState({
                userInfo: response.data,
              });
              if (response.data.has_membership) {
                this.setState({
                  hasMembership: true,
                });
              }
            })
            .catch((error) => {
              console.log('failed to get user info');
              console.log(error.response);
              this.setState({
                snackbarOpen: true,
                snackbarVariant: 'error',
                snackbarMessage: 'Failed to load your trainer info',
              });
            });
        }

        // if user is logged in (and routines), check to see if they have a membership
        // if (token && id && (category === 'routines') && !hasMembership) {
        //   getBraintreeCustomer(token, id)
        //     .then((response) => {
        //       console.log('got braintree customer');
        //       // console.log(response.data);
        //       // see if any payment source has subscription attached
        //       if (response.data.payment_methods.length > 0) {
        //         response.data.payment_methods.forEach((paymentMethod) => {
        //           if (paymentMethod.subscriptions.length > 0) {
        //             paymentMethod.subscriptions.forEach((subscription) => {
        //               if (subscription.status === 'Active') {
        //                 this.setState({ hasMembership: true });
        //                 // console.log('user has membership');
        //               }
        //             });
        //           }
        //         });
        //       }
        //     })
        //     .catch((error) => {
        //       // console.log(error);
        //       this.setState({
        //         snackbarOpen: true,
        //         snackbarVariant: 'error',
        //         snackbarMessage: 'Failed to load your membership data',
        //       });
        //     });
        // }
      })
      .catch((error) => {
        // console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to load products',
          loading: false,
        });
      });
  }

  addToCart(e, productUrl) {
    const { token } = this.props;
    this.setState({ addButtonLoading: true });
    addProductToCart(token, productUrl)
      .then((response) => {
        this.setState({
          addButtonLoading: false,
          snackbarOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: 'Product added to cart',
        });
      })
      .catch((error) => {
        // console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to add product',
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    function createMarkup(html) {
      return { __html: html };
    }
    const { classes } = this.props;
    const {
      loggedIn,
      hasMembership,
      loading,
      product,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
      addButtonLoading,
      category,
    } = this.state;
    // routine special handling
    let allowAdd = loggedIn;
    let tooltipText = 'Must be Logged In';
    if (category === 'Routines') {
      allowAdd = loggedIn && hasMembership;
      tooltipText = 'Must have a Nia Membership';
    }
    return (
      <React.Fragment>
        <Typography className={classes.header} color="textSecondary" variant="h4">Product Detail</Typography>
        {/* PRODUCTS DETAIL */}
        <Paper className={classes.paper}>
          {loading
            ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
            : (
              <Grid justifyContent="center" container spacing={3}>

                {/* IMAGE */}
                <Grid item md={6}>
                  {product.images
                    ? <img alt="product" className={classes.media} src={product.images[0].original} />
                    : <img alt="product" className={classes.media} src={productPlaceholder} />
                  }
                </Grid>

                {/* DETAILS */}
                <Grid item md={6}>
                  <div className={classes.sectionContent}>
                    <Typography variant="h5" className={classes.sectionTitle}>{product.title}</Typography>
                    <div className={classes.font} dangerouslySetInnerHTML={createMarkup(product.description)} />
                  </div>
                  <span className={classes.buttonAndPrice}>
                    <Typography className={classes.price} variant="h5">{'$' + product.price.incl_tax}</Typography>
                    {addButtonLoading
                      ? <Button className={classes.button} variant="outlined" disabled>adding..</Button>
                      : (
                        <React.Fragment>
                          {allowAdd
                            ? <Button className={classes.button} onClick={e => this.addToCart(e, product.url)} variant="contained" color="secondary">Add to Cart</Button>
                            : (
                              <Tooltip title={tooltipText} placement="right">
                                <div>
                                  <Button disabled className={classes.button} size="small" color="secondary" variant="contained">Add to Cart</Button>
                                </div>
                              </Tooltip>
                            )
                         }
                        </React.Fragment>
                      )
                    }
                  </span>
                </Grid>

                <Grid container justifyContent="space-between">
                  <Grid item>
                    <Button component={Link} to="/shop/category/music">Continue Shopping</Button>
                  </Grid>
                  <Grid item>
                    {loggedIn
                      ? (
                        <React.Fragment>
                          <Button component={Link} to="/shop/cart">View Cart</Button>
                          <Button component={Link} to="/shop/checkout" color="secondary">Checkout Now</Button>
                        </React.Fragment>
                      )
                      : (
                        <React.Fragment>
                          <Tooltip title="Must be logged in" placement="right">
                            <div className={classes.tooltipWrapper}>
                              <Button disabled component={Link} to="/shop/cart">View Cart</Button>
                            </div>
                          </Tooltip>
                          <Tooltip title="Must be logged in" placement="left">
                            <div className={classes.tooltipWrapper}>
                              <Button disabled component={Link} to="/shop/checkout" color="secondary">Checkout Now</Button>
                            </div>
                          </Tooltip>
                        </React.Fragment>
                      )
                    }
                  </Grid>
                </Grid>
              </Grid>
            )
          }
        </Paper>

        {/* SNACKBAR */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarVariant}
            message={snackbarMessage}
          />
        </Snackbar>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  let id = null;
  let token = null;
  if (state.loginReducer.user) {
    id = state.loginReducer.user.id;
    token = state.loginReducer.token;
  }
  return {
    id,
    token,
  };
}

ProductDetail.propTypes = {
  id: PropTypes.number,
  token: PropTypes.string,
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(connect(mapStateToProps)(ProductDetail));
